// extracted by mini-css-extract-plugin
module.exports = {"root":"SortableItem_root__gomNz","dragIcon":"SortableItem_dragIcon__2cn6d","disabled":"SortableItem_disabled__1O1TT"};